// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"66306e1a","128":"a9a87e43","665":"db6bdb79","742":"ddd652d4","818":"53767859"}[chunkId] + ".css";
};